export const pillarToFilledIcon = {
  understandFinances: 'pillarUnderstandFinancesFilled',
  maximizeValue: 'pillarMaximizeValueFilled',
  reduceDebt: 'pillarReduceDebtsFilled',
  controlSpending: 'pillarControlSpendingFilled',
  buildSafetyNet: 'pillarBuildSafetyNetFilled',
  useBenefits: 'pillarUseBenefitsFilled',
};

export const pillarToOutlinedIcon = {
  understandFinances: 'pillarUnderstandFinancesOutlined',
  maximizeValue: 'pillarMaximizeValueOutlined',
  reduceDebt: 'pillarReduceDebtsOutlined',
  controlSpending: 'pillarControlSpendingOutlined',
  buildSafetyNet: 'pillarBuildSafetyNetOutlined',
  useBenefits: 'pillarUseBenefitsOutlined',
};
